if (!customElements.get("cart-upgrades")) {
  class CartUpgrades extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.checkboxes = [];
    }

    connectedCallback() {
      this.initSlider();
      this.initCheckboxes();
    }

    disconnectedCallback() {
      this.destroySlider();
    }

    /* ---------- SLIDER ---------- */

    initSlider() {
      const sliderEl = this.querySelector(".product-upgrades-slider");
      if (!sliderEl) return;

      const nextEl = this.querySelector(".product-upgrades__arrow--next");
      const prevEl = this.querySelector(".product-upgrades__arrow--prev");

      this.swiper = new Swiper(sliderEl, {
        slidesPerView: 1.5,
        spaceBetween: 8,

        freeMode: {
          enabled: true,
        },
        cssMode: false,
        grabCursor: true,
        simulateTouch: true,

        navigation: {
          nextEl,
          prevEl,
        },

        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },

        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 12,
          }
        },
      });
    }


    destroySlider() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    /* ---------- CART / CHECKBOXES ---------- */

    async initCheckboxes() {
      this.checkboxes = Array.from(
        this.querySelectorAll(".product-upgrades__item-id")
      );
      if (!this.checkboxes.length) return;

      this.checkboxes.forEach((checkbox) => {
        const itemEl = checkbox.closest(".product-upgrades__item");

        this.toggleItemState(itemEl, checkbox.checked);

        checkbox.addEventListener("change", (event) =>
          this.onCheckboxChange(event)
        );
      });
    }

    toggleItemState(itemEl, isChecked) {
      if (!itemEl) return;
      itemEl.classList.toggle("product-upgrades__item--checked", isChecked);
    }

    async onCheckboxChange(event) {
      const checkbox = event.target;
      const variantId = checkbox.value;
      const itemEl = checkbox.closest(".product-upgrades__item");

      try {
        if (checkbox.checked) {
          await this.addToCart(variantId);
          this.toggleItemState(itemEl, true);
        } else {
          await this.removeFromCart(variantId);
          this.toggleItemState(itemEl, false);
        }

        document.dispatchEvent(
          new CustomEvent("cart:added", {
            detail: {
              item: { id: Number(variantId) },
            },
          })
        );
      } catch (err) {
        console.error("Cart update failed", err);
        checkbox.checked = !checkbox.checked;
        this.toggleItemState(itemEl, checkbox.checked);
      }
    }


    async fetchCart() {
      const res = await fetch("/cart.js", {
        headers: {
          "Accept": "application/json",
        },
      });
      if (!res.ok) throw new Error("Cart fetch failed");
      return res.json();
    }

    async addToCart(variantId) {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1,
        }),
      });

      if (!res.ok) throw new Error("Add to cart failed");
      return res.json();
    }

    async removeFromCart(variantId) {
      const cart = await this.fetchCart();
      const item = cart.items.find(
        (item) => item.variant_id === Number(variantId)
      );

      if (!item) return;

      const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify({
          id: item.key,
          quantity: 0,
        }),
      });

      if (!res.ok) throw new Error("Remove from cart failed");
      return res.json();
    }
  }

  customElements.define("cart-upgrades", CartUpgrades);
}
